module.exports = __webpack_public_path__ + "m-search-2-007ea385.svg";